import { TableView } from 'owa-mail-list-store';
import { InstrumentationContext } from 'owa-mail-store';
import { getInstrumentationContext } from 'owa-mail-list-store/lib/selectors/mailRowDataPropertyGetter';

/**
 *
 * @param rowKeys string[] holding rowKeys from tableView
 * @param tableView tableView containing rowKeys
 */
export default function getInstrumentationContextsFromTableView(
    rowKeys: string[],
    tableView: TableView
): InstrumentationContext[] {
    const instrumentationContexts = rowKeys.map(rowKey => {
        const instrumentationContext = getInstrumentationContext(rowKey, tableView);
        return instrumentationContext;
    });
    return instrumentationContexts.filter(ic => ic);
}
